var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridVideo',_vm._b({ref:"mapRef",attrs:{"src":_vm.composedSrc,"render-iframe":_vm.renderIframe,"render-picture":_vm.renderPicture},on:{"~click":function($event){_vm.renderIframe = true}}},'GridVideo',_vm.composedProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }